import axios from 'axios';

// A random tab session only: no account identity, fingerprinting, or third-party trackers.
export function prepareSalesTracking(): void {
    try {
        if (navigator.doNotTrack === '1') return;
        let session = sessionStorage.getItem('dream_sales_session');
        if (!session) {
            const random = new Uint8Array(16);
            crypto.getRandomValues(random);
            session = Array.from(random, value => value.toString(16).padStart(2, '0')).join('');
            sessionStorage.setItem('dream_sales_session', session);
        }
        let source = sessionStorage.getItem('dream_sales_source');
        if (!source) {
            const campaign = new URLSearchParams(window.location.search).get('utm_source');
            const referrer = document.referrer ? new URL(document.referrer).hostname : '';
            source = campaign || (referrer && referrer !== window.location.hostname ? referrer : 'direct');
            source = /^[a-zA-Z0-9_.-]{1,64}$/.test(source) ? source.toLowerCase() : 'direct';
            sessionStorage.setItem('dream_sales_source', source);
        }
        axios.defaults.headers.common['X-Funnel-Session'] = session;
        axios.defaults.headers.common['X-Funnel-Source'] = source;
    } catch { /* Storage restrictions must not affect checkout. */ }
}

export function trackSalesVisit(): void {
    prepareSalesTracking();
    const session = axios.defaults.headers.common['X-Funnel-Session'];
    if (!session) return;
    try {
        const day = new Date().toISOString().slice(0, 10);
        if (sessionStorage.getItem('dream_sales_visit_day') === day) return;
        sessionStorage.setItem('dream_sales_visit_day', day);
        void axios.post('/analytics/visit', { session, source: axios.defaults.headers.common['X-Funnel-Source'] })
            .catch(() => { try { sessionStorage.removeItem('dream_sales_visit_day'); } catch { /* ignored */ } });
    } catch { /* No storage means no visit tracking. */ }
}
